import { render, staticRenderFns } from "./ViewActiveMembers.vue?vue&type=template&id=bbd12ce6&scoped=true"
import script from "./ViewActiveMembers.vue?vue&type=script&lang=js"
export * from "./ViewActiveMembers.vue?vue&type=script&lang=js"
import style0 from "./ViewActiveMembers.vue?vue&type=style&index=0&id=bbd12ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd12ce6",
  null
  
)

export default component.exports